import { useMemo } from 'react';

import { getTokenValue, Token } from '@tamagui/core';
import { BlurView, BlurViewProps } from 'expo-blur';

type BackgroundBlurProps = Omit<BlurViewProps, 'intensity'> & {
  /** A pixel value, up to 20 */
  blurRadius: Token | number;
};

/**
 * Blurs content behind the view.
 */
export const BackgroundBlur = ({ blurRadius, ...props }: BackgroundBlurProps) => {
  const intensity = useMemo(() => {
    const blurPxValue =
      typeof blurRadius === 'number' ? blurRadius : getTokenValue(blurRadius, 'backgroundBlur');

    // Pixel value is 20% of intensity. See: https://github.com/expo/expo/blob/main/packages/expo-blur/src/BlurView.web.tsx#L56C39-L56C69
    return blurPxValue * 5;
  }, [blurRadius]);

  return <BlurView {...props} intensity={intensity} />;
};
